import styles from "./LatestNews.module.scss";
import iconStyles from "../../../components/Icon.module.scss";
import buttonStyles from "../../../components/Button.module.scss";
import ModalWithPicture, {
  ModalWithPictureDialogProps,
  ModalWithPictureHandle,
} from "../../../components/ModalWithPicture/ModalWithPicture";
import { useEffect, useRef, useState } from "react";
import { getExcerpt } from "../../../utils/helpers";
import { useQuery } from "@apollo/client";
import { getEvents } from "../../../services/getContent";
import Loader from "../../../components/Loader/Loader";

interface NewsData {
  image: string;
  title: string;
  excerpt: string;
  content: string;
  link: string;
}

const getEventSummary = (eventData: any): NewsData => {
  const image = eventData.featuredImage?.node?.mediaItemUrl;
  const title = eventData.title;
  const content = getExcerpt(eventData.content);
  const excerpt = eventData.excerpt;
  const link = eventData.uri;
  const data = { image, title, content, excerpt, link };
  return data;
};

const isValidUrl = (str: string): boolean => {
  try {
    new URL(str);
    return true;
  } catch (_) {
    return false;
  }
};

const LatestNews = () => {
  const modalRef = useRef<ModalWithPictureHandle>(null);

  // this is for featuredEvent but turned as for now
  // const [featuredEvent, setFeaturedEvent] = useState({
  //   image: "",
  //   title: "",
  //   content: "",
  //   excerpt: "",
  // });
  const [allEvents, setAllEvents] = useState<NewsData[]>([]);

  const { loading, error, data } = useQuery(
    getEvents("categoryName", "events"),
  );
  // const {
  //   loading: featuredEventLoading,
  //   error: featuredEventError,
  //   data: featuredEventData,
  // } = useQuery(getEvents("tag", "featured"));

  // useEffect(() => {
  //   if (featuredEventData) {
  //     const summaryFeatured = getEventSummary(featuredEventData.posts.nodes[0]);
  //     setFeaturedEvent(summaryFeatured);
  //   }
  // }, [featuredEventData]);

  useEffect(() => {
    if (data) {
      let eventsList: NewsData[] = [];
      data.posts.nodes.forEach((eventData: any) => {
        const summary = getEventSummary(eventData);
        eventsList.push(summary);
      });
      setAllEvents(eventsList);
    }
  }, [data]);

  const showModal = (dialogProps: ModalWithPictureDialogProps) => {
    modalRef.current?.onOpen(dialogProps);
  };

  return (
    <>
      <section id="latest" className={styles.latest}>
        <div className={styles.title}>
          <h2>Lately at</h2>
          <h3>IREC Stockholm</h3>
        </div>
        <div className={styles["card-container"]}>
          {loading && <Loader />}
          {!loading &&
            allEvents.map((eventContent, _) => {
              if (isValidUrl(eventContent.content)) {
                return (
                  <div className={styles.card} key={eventContent.title}>
                    <img className={styles.post} src={eventContent.image} />
                    <div className={styles.overlay}>
                      <a
                        href={eventContent.content}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <button className={buttonStyles.invert}>
                          <span
                            className={`${iconStyles.icon} ${styles.icon} ${iconStyles.youtube}`}
                          ></span>
                          Watch
                        </button>
                      </a>
                    </div>
                  </div>
                );
              } else {
                const dialogProps: ModalWithPictureDialogProps = {
                  excerpt: eventContent.excerpt,
                  description: eventContent.content,
                  title: eventContent.title,
                  image: eventContent.image,
                };

                return (
                  <div
                    className={styles.card}
                    key={eventContent.title}
                    onClick={() => showModal(dialogProps)}
                  >
                    <img className={styles.post} src={eventContent.image} />
                    <div className={styles.overlay}>
                      <button
                        className={buttonStyles.invert}
                        onClick={() => showModal(dialogProps)}
                      >
                        View details
                      </button>
                    </div>
                  </div>
                );
              }
            })}
        </div>
      </section>

      <ModalWithPicture ref={modalRef} />
    </>
  );
};

export default LatestNews;
